import axios from 'axios';
import dataToFilter from './data.json';
import { matchSorter } from 'match-sorter';

// function filterProperties(filters) {
//   // Helper to get nested property values
//   const getNestedValue = (obj, path) => {
//     return path
//       .split('.')
//       .reduce(
//         (acc, part) => (acc && acc[part] !== undefined ? acc[part] : null),
//         obj
//       );
//   };

//   // Operator handlers
//   const operators = {
//     $eq: (a, b) => a == b, // Loose equality, change to === for strict if needed
//     $ne: (a, b) => a != b, // Loose inequality, change to !== for strict if needed
//     $gt: (a, b) => {
//       const numA = parseFloat(a);
//       const numB = parseFloat(b);
//       return !isNaN(numA) && !isNaN(numB) && numA > numB;
//     },
//     $gte: (a, b) => {
//       const numA = parseFloat(a);
//       const numB = parseFloat(b);
//       return !isNaN(numA) && !isNaN(numB) && numA >= numB;
//     },
//     $lt: (a, b) => {
//       const numA = parseFloat(a);
//       const numB = parseFloat(b);
//       return !isNaN(numA) && !isNaN(numB) && numA < numB;
//     },
//     $lte: (a, b) => {
//       const numA = parseFloat(a);
//       const numB = parseFloat(b);
//       return !isNaN(numA) && !isNaN(numB) && numA <= numB;
//     },
//     $in: (a, b) => Array.isArray(b) && b.some((val) => a == val),
//     $nin: (a, b) => Array.isArray(b) && !b.includes(a),
//     $regex: (a, b) => {
//       try {
//         // Ensure 'a' is a string for regex testing
//         return new RegExp(b, 'i').test(String(a));
//       } catch (e) {
//         return false; // Invalid regex pattern
//       }
//     },
//     $size: (a, b) =>
//       Array.isArray(a) && typeof b === 'number' && a.length === b,
//     $has: (a, b) =>
//       Array.isArray(a) &&
//       a.some(
//         (itemElem) =>
//           itemElem && typeof itemElem === 'object' && itemElem.type === b
//       ),
//     // $matchSorter: (itemValue, searchValue) => {
//     //   if (itemValue == null) return false;
//     //   return matchSorter([String(itemValue)], searchValue).length > 0;
//     // },
//   };

//   // Validate input: dataToFilter must be an array
//   if (!Array.isArray(dataToFilter)) {
//     // console.warn("filterProperties: dataToFilter must be an array. Returning empty array.");
//     return [];
//   }

//   // Validate input: filters must be a plain object
//   if (
//     filters === null ||
//     filters === undefined ||
//     typeof filters !== 'object' ||
//     Array.isArray(filters)
//   ) {
//     // console.warn("filterProperties: Invalid or no filters provided. Returning all data.");
//     return dataToFilter; // Or return [] if invalid filters should clear results
//   }

//   // If filters object is empty, return all data
//   if (Object.keys(filters).length === 0) {
//     return dataToFilter;
//   }

//   // Apply filters to each item in dataToFilter
//   return dataToFilter.filter((item) => {
//     for (const [field, condition] of Object.entries(filters)) {
//       // if (field === "area.name" && typeof condition === "string") {
//       //   const areaName = getNestedValue(item, "area.name");

//       //   // Handle null/undefined values
//       //   if (areaName == null) return false;

//       //   // Convert to string if needed
//       //   const searchString = String(areaName);

//       //   // Use match-sorter to check for matches
//       //   const matches = matchSorter([searchString], condition);

//       //   // If no matches, exclude this item
//       //   if (matches.length === 0) return false;

//       //   // Continue to next field if matched
//       //   continue;
//       // }

//       if (field === 'area.name') {
//         const areaName = getNestedValue(item, 'area.name');

//         // Handle $in operator with fuzzy matching
//         if (
//           typeof condition === 'object' &&
//           condition.$in &&
//           Array.isArray(condition.$in)
//         ) {
//           if (areaName == null) return false;

//           const strAreaName = String(areaName);
//           const matches = condition.$in.some(
//             (searchTerm) => matchSorter([strAreaName], searchTerm).length > 0
//           );

//           if (!matches) return false;

//           // Store match details
//           item.__matchDetails = item.__matchDetails || {};
//           item.__matchDetails['area.name'] = {
//             original: areaName,
//             matchedSearchTerms: condition.$in.filter(
//               (term) => matchSorter([strAreaName], term).length > 0
//             ),
//           };
//           continue;
//         }

//         // Handle direct string filter
//         if (typeof condition === 'string') {
//           if (areaName == null) return false;

//           const strAreaName = String(areaName);
//           if (matchSorter([strAreaName], condition).length === 0) return false;

//           // Store match details
//           item.__matchDetails = item.__matchDetails || {};
//           item.__matchDetails['area.name'] = {
//             original: areaName,
//             matchedSearchTerms: [condition],
//           };
//           continue;
//         }
//       }

//       // Handle logical OR operator
//       if (field === '$or') {
//         if (!Array.isArray(condition)) {
//           // console.warn("$or condition must be an array. Filter failed for this item.");
//           return false; // Malformed $or condition
//         }
//         // If any sub-filter in the $or array matches, the $or condition is met.
//         // If condition is an empty array, .some() returns false, so !false is true, leading to 'return false'.
//         // This means an empty $or [] makes the item fail this $or clause, which is logical.
//         if (
//           !condition.some(
//             (subFilter) => filterProperties([item], subFilter).length > 0
//           )
//         ) {
//           return false;
//         }
//         continue; // Move to the next field in filters
//       }

//       // Handle logical AND operator
//       if (field === '$and') {
//         if (!Array.isArray(condition)) {
//           // console.warn("$and condition must be an array. Filter failed for this item.");
//           return false; // Malformed $and condition
//         }
//         // All sub-filters in the $and array must match.
//         // If condition is an empty array, .every() returns true, so !true is false. The 'if' is not entered.
//         // This means an empty $and [] is a pass for this $and clause, which is logical.
//         if (
//           !condition.every(
//             (subFilter) => filterProperties([item], subFilter).length > 0
//           )
//         ) {
//           return false;
//         }
//         continue; // Move to the next field in filters
//       }

//       // Get the value of the current field from the item
//       const itemValue = getNestedValue(item, field);

//       // Process condition if it's an object (e.g., { $gt: 10, $lt: 20 } or nested like { subfield: 'value' })
//       if (
//         typeof condition === 'object' &&
//         condition !== null &&
//         !Array.isArray(condition)
//       ) {
//         let conditionPassed = true; // Assume true until a check fails
//         // Iterate over operators or nested fields within the condition object
//         for (const [op, opValue] of Object.entries(condition)) {
//           if (operators[op]) {
//             // If 'op' is a known operator (e.g., $gt, $regex)
//             if (!operators[op](itemValue, opValue)) {
//               conditionPassed = false;
//               break; // Operator condition failed
//             }
//           } else {
//             // If 'op' is a nested field (e.g., area: { name: '...' })
//             // Recursively filter the itemValue (which should be an object for this to be meaningful)
//             // If itemValue is not an object, filterProperties([itemValue], ...) will likely result in an empty array.
//             const nestedDataToFilter =
//               itemValue !== null && typeof itemValue === 'object'
//                 ? [itemValue]
//                 : [];
//             const nestedResult = filterProperties(nestedDataToFilter, {
//               [op]: opValue,
//             });
//             if (nestedResult.length === 0) {
//               conditionPassed = false;
//               break; // Nested condition failed
//             }
//           }
//         }
//         if (!conditionPassed) return false; // If any part of the object condition failed
//       } else {
//         // Direct value comparison (implicit $eq)
//         if (!operators.$eq(itemValue, condition)) {
//           return false;
//         }
//       }
//     }
//     return true; // All conditions in filters passed for this item
//   });
// }

const cities = [
  {
    id: 1,
    name: 'Islamabad',
  },
  {
    id: 169,
    name: 'Karachi',
  },
  {
    id: 2,
    name: 'Lahore',
  },
  {
    id: 176,
    name: 'Peshawar',
  },
  {
    id: 3,
    name: 'Rawalpindi',
  },
  {
    id: 182,
    name: 'Abbottabad ',
  },
  {
    id: 180,
    name: 'Attock ',
  },
  {
    id: 221,
    name: 'Bagh',
  },
  {
    id: 175,
    name: 'Bahawalpur',
  },
  {
    id: 201,
    name: 'Bannu',
  },
  {
    id: 218,
    name: 'Batgram',
  },
  {
    id: 229,
    name: 'Bhimber',
  },
  {
    id: 213,
    name: 'Buner',
  },
  {
    id: 177,
    name: 'Chakwal',
  },
  {
    id: 197,
    name: 'Charsadda',
  },
  {
    id: 212,
    name: 'Chitral',
  },
  {
    id: 188,
    name: 'Daska',
  },
  {
    id: 189,
    name: 'Dera Ghazi Khan',
  },
  {
    id: 203,
    name: 'DI Khan',
  },
  {
    id: 243,
    name: 'Dina',
  },
  {
    id: 211,
    name: 'Dir Lower',
  },
  {
    id: 210,
    name: 'Dir Upper',
  },
  {
    id: 170,
    name: 'Faisalabad',
  },
  {
    id: 196,
    name: 'Fateh Jhang',
  },
  {
    id: 228,
    name: 'Ghanche',
  },
  {
    id: 184,
    name: 'Gilgit',
  },
  {
    id: 241,
    name: 'Gujar Khan',
  },
  {
    id: 174,
    name: 'Gujranwala',
  },
  {
    id: 233,
    name: 'Gujrat',
  },
  {
    id: 179,
    name: 'Gwadar',
  },
  {
    id: 202,
    name: 'Hangu',
  },
  {
    id: 214,
    name: 'Haripur',
  },
  {
    id: 181,
    name: 'Hasanabdal',
  },
  {
    id: 222,
    name: 'Haveli',
  },
  {
    id: 226,
    name: 'Hunza',
  },
  {
    id: 183,
    name: 'Hyderabad',
  },
  {
    id: 193,
    name: 'Jhelum',
  },
  {
    id: 200,
    name: 'Karak',
  },
  {
    id: 191,
    name: 'Kashmir',
  },
  {
    id: 273,
    name: 'Kasur',
  },
  {
    id: 240,
    name: 'Khanewal',
  },
  {
    id: 185,
    name: 'Khanpur',
  },
  {
    id: 235,
    name: 'Kharian',
  },
  {
    id: 199,
    name: 'Kohat',
  },
  {
    id: 216,
    name: 'Kohistan',
  },
  {
    id: 220,
    name: 'Kotli',
  },
  {
    id: 205,
    name: 'Lakki Marwat',
  },
  {
    id: 234,
    name: 'Lalamusa',
  },
  {
    id: 208,
    name: 'Malakand PA',
  },
  {
    id: 244,
    name: 'Mangla',
  },
  {
    id: 215,
    name: 'Mansehra',
  },
  {
    id: 171,
    name: 'Mardan',
  },
  {
    id: 192,
    name: 'Mirpur (Azad Kashmir)',
  },
  {
    id: 168,
    name: 'Multan',
  },
  {
    id: 167,
    name: 'Murree',
  },
  {
    id: 219,
    name: 'Muzaffarabad',
  },
  {
    id: 232,
    name: 'Nawabshah',
  },
  {
    id: 225,
    name: 'Neelam',
  },
  {
    id: 195,
    name: 'Nowshera',
  },
  {
    id: 194,
    name: 'Okara',
  },
  {
    id: 223,
    name: 'Poonch',
  },
  {
    id: 187,
    name: 'Quetta',
  },
  {
    id: 306,
    name: 'Sahiwal',
  },
  {
    id: 230,
    name: 'Sarai Alamgir',
  },
  {
    id: 172,
    name: 'Sargodha',
  },
  {
    id: 209,
    name: 'Shangla',
  },
  {
    id: 186,
    name: 'Sheikhupura',
  },
  {
    id: 190,
    name: 'Sialkot',
  },
  {
    id: 227,
    name: 'Skardu',
  },
  {
    id: 224,
    name: 'Sudhanoti',
  },
  {
    id: 207,
    name: 'Sukkur',
  },
  {
    id: 198,
    name: 'Swabi',
  },
  {
    id: 206,
    name: 'Swat',
  },
  {
    id: 178,
    name: 'Talagang',
  },
  {
    id: 204,
    name: 'Tank',
  },
  {
    id: 166,
    name: 'Taxila',
  },
  {
    id: 217,
    name: 'Torghar',
  },
  {
    id: 173,
    name: 'Wah',
  },
  {
    id: 236,
    name: 'Wazirabad',
  },
];

async function callApi({ method, url, query }) {
  const BASE_URL = `https://www.graana.com`;
  let endpoint = `${BASE_URL}/${url}`;
  const queryItems = Object.fromEntries(
    Object.entries(query).filter(([_, v]) => v)
  );
  if (queryItems && Object.keys(queryItems)?.length > 0) {
    const queryParams = Object.entries(queryItems)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
    endpoint = `${endpoint}?${queryParams}`;
  }
  let axiosConfig = {
    method,
    url: endpoint,
  };
  console.log({ endpoint });
  const response = await axios(axiosConfig);
  return response.data;
}

async function filterProperties(filters) {
  if (!filters?.purpose)
    return {
      error: true,
      message: 'Please specify the property purpose (e.g., for sale or rent).',
    };

  let cityId = null;
  const city = filters?.city;
  if (!city) return { error: true, message: 'City is required to proceed.' };
  if (city) {
    cityId = cities.find(
      (c) => c.name?.toLocaleLowerCase() == city?.toLocaleLowerCase()
    )?.id;

    if (!cityId) {
      const cityRes = await callApi({
        method: 'get',
        url: 'data/cities',
      });
      cityId = cityRes?.data?.find(
        (c) => c.name?.toLocaleLowerCase() == city?.toLocaleLowerCase()
      )?.id;
    }

    console.log({ cityId });
  }

  let areaId = '';
  const area =
    filters.area
      ?.split(',')
      .map((s) => s.trim().toLowerCase())
      .filter(Boolean) || [];
  if (area?.length) {
    const isSingle = area?.length == 1;
    const areaRes = await callApi({
      method: 'get',
      url: 'search/cityArea',
      query: {
        cityId,
        searchQuery: filters?.area,
      },
    });
    const data = areaRes?.data?.filter((a) => a.areaId);
    let fltr = null;
    if (isSingle) {
      fltr = data.slice(0, 1);
    } else {
      fltr = area
        .map((area) => {
          const match = data.find((item) =>
            item.name.toLowerCase().includes(area)
          );
          return match || null;
        })
        .filter(Boolean);
    }
    areaId = fltr.reduce((acc, item, idx) => {
      acc[`areaId[${idx}]`] = item.areaId;
      return acc;
    }, {});
  }

  const beds = filters?.bed;
  let bedsData = { 'bed[]': beds };
  if (typeof beds === 'string') {
    const bedsArray = beds.split(',');
    bedsData = bedsArray.reduce((acc, bed, idx) => {
      acc[`bed[${idx}]`] = bed;
      return acc;
    }, {});
  }

  const baths = filters?.bath;
  let bathsData = { 'bath[]': baths };
  if (typeof baths === 'string') {
    const bathsArray = baths.split(',');
    bathsData = bathsArray.reduce((acc, bath, idx) => {
      acc[`bath[${idx}]`] = bath;
      return acc;
    }, {});
  }

  const subtype = filters?.subtype;
  let subtypeData = { 'subtype[]': subtype };
  if (typeof subtype === 'string') {
    const subtypeArray = subtype.split(',');
    subtypeData = subtypeArray.reduce((acc, type, idx) => {
      acc[`subtype[${idx}]`] = type;
      return acc;
    }, {});
  }

  const finalData = {
    ...bedsData,
    ...bathsData,
    ...subtypeData,
    ...areaId,
  };

  let query = {
    cityId: cityId,
    purpose: filters?.purpose,
    condition: filters?.condition,
    priceMin: filters?.priceMin,
    priceMax: filters?.priceMax,
    sizeMin: filters?.sizeMin,
    sizeMax: filters?.sizeMax,
    sizeUnit: filters?.sizeUnit,
    type: filters?.type,
    ...finalData,
    orderBy: 1,
    page: filters?.page,
    pageSize: filters?.pageSize,
  };
  console.log({ query });
  const optData = await callApi({
    method: 'get',
    url: 'search/listings',
    query,
  });
  console.log({ optData });

  const properties = optData?.data?.map((p) => {
    return {
      url: p?.propertyImages[0]?.url,
      type: p?.type,
      purpose: p?.purpose,
      subtype: p?.subtype,
      size: p?.size,
      sizeUnit: p?.sizeUnit,
      bath: p?.bath,
      bed: p?.bed,
      price: p?.price,
      area: p?.area?.name,
      city: p?.city?.name,
    };
  });

  return {
    success: true,
    properties: properties,
    count: optData?.count,
  };
}

export default filterProperties;
